import amplitude from '@lib/analytics/amplitude'

export const useHelpAnalytics = () => {
  const trackClickHelpCenter = () => {
    amplitude.help.clickHelpCenter()
  }

  return {
    trackClickHelpCenter,
  }
}
